import { PENDING_PAYMENT_METHOD_KEY } from '@/constants';

export const getPendingPaymentMethodKey = (organizationId?: string | null) =>
  `${organizationId}/${PENDING_PAYMENT_METHOD_KEY}`;
